/**
 * Author：brand
 * Creation Time：2019-05-15 11:01
 * Email：brandhuang@qq.com
 */
import Vue from 'vue'

import SvgIcon from '@/components/svg/svg-icon' // svg组件

// register globally

Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)

const req = require.context('./svg', false, /\.svg$/)

requireAll(req)
